/**
 * @generated SignedSource<<299ecb4ed6fbaac84cfe77dbfdb2d31f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespIconBubbleShare_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedIconBubbleEmail_user">;
  readonly " $fragmentType": "PdpRespIconBubbleShare_user";
};
export type PdpRespIconBubbleShare_user$key = {
  readonly " $data"?: PdpRespIconBubbleShare_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespIconBubbleShare_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespIconBubbleShare_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedIconBubbleEmail_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "f6a8e93d009784d256ede0ec2a5f751e";

export default node;
